var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 20C35 28.2843 28.2843 35 20 35C11.7157 35 5 28.2843 5 20C5 11.7157 11.7157 5 20 5C28.2843 5 35 11.7157 35 20Z",
    fill: "#1A1A1A",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4471 25.0376C23.8865 25.477 24.5988 25.477 25.0381 25.0376C25.4775 24.5983 25.4775 23.886 25.0381 23.4466L21.5911 19.9996L25.0381 16.5525C25.4774 16.1132 25.4774 15.4009 25.0381 14.9615C24.5988 14.5222 23.8865 14.5222 23.4471 14.9615L20.0001 18.4086L16.5528 14.9613C16.1135 14.522 15.4012 14.522 14.9619 14.9613C14.5225 15.4007 14.5225 16.113 14.9619 16.5523L18.4091 19.9996L14.9618 23.4468C14.5225 23.8862 14.5225 24.5985 14.9618 25.0378C15.4012 25.4771 16.1135 25.4771 16.5528 25.0378L20.0001 21.5906L23.4471 25.0376Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.57bbb439815b1b3bc9f338abd4f3b7da.svg";
export { ForwardRef as ReactComponent };